var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 25.333h6a.666.666 0 110 1.334H6.001A.667.667 0 015.334 26V8.667a.677.677 0 01.196-.472l5.332-5.332a.66.66 0 01.216-.144.642.642 0 01.256-.052h14.667c.369 0 .666.297.666.666v9.334a.667.667 0 01-1.333 0V4H12.001v4.667a.666.666 0 01-.667.666H6.667v16zm4-20.39L7.61 8h3.057V4.943zm18.864 19.25a.666.666 0 11.94.946l-6.708 6.666a.666.666 0 01-.941 0l-6.708-6.666a.666.666 0 11.94-.945l5.613 5.578V16.667a.666.666 0 111.333 0v13.022l5.531-5.496zm-14.864-10.86V8.667a.667.667 0 00-1.333 0v4.666a.667.667 0 001.333 0zm-2.666-2.666v5.237h4v-5.237h.777c.308 0 .556.238.556.533v9.6a.544.544 0 01-.555.533h-5.556a.544.544 0 01-.556-.533v-9.6c0-.295.248-.533.556-.533h.778zM15.97 20v-1.333H12V20h3.97z",
    fill: "#848999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressed);
export default __webpack_public_path__ + "static/media/compressed.6ea8a3f304b133b5ae154fe1ae1258a0.svg";
export { ForwardRef as ReactComponent };